<template>
    <div :style="inputWrapperStyle">
      <v-menu
        v-model="menu"
        :offset-y="true"
        :close-on-content-click="false"
        style="max-width: 70%"
        :disabled="disabled"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            clearable
            append-icon="mdi-calendar-clock"
            :value="transformedValue"
            solo
            flat
            background-color="#E7E7FF"
            placeholder="Select Date & Time"
            v-on="on"
            readonly
            :disabled="disabled"
          />
        </template>
        <v-card style="padding: 22px 24px 22px 0;" v-if="!disabled">
          <div style="display: flex; gap: 5px">
            <v-date-picker
              color="#050D92"
              v-model="selectedDate"
              no-title
              scrollable
              :min="minDate"
              :max="maxDate"
              @input="onDateInput"
            />
            <section>
              <div
                style="display: flex; gap: 5px; justify-content: space-around; margin-top: 10px;"
              >
                <div
                  style="border: 1px solid #a8a8a8; border-radius: 4px; padding: 5px;"
                >
                  <div style="text-align: center; padding: 2px">
                    <div style="font-size: 16px; font-weight: 600">Hour</div>
                  </div>
                  <v-list class="scrollable-list">
                    <v-list-item-group v-model="selectedHours" color="#050D92">
                      <v-list-item
                        v-for="(hour, index) in hours"
                        :key="`hour-${index}`"
                        :value="hour"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ hour }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </div>
                <div
                  style="border: 1px solid #a8a8a8; border-radius: 4px; padding: 5px;"
                >
                  <div style="text-align: center; padding: 2px">
                    <div style="font-size: 16px; font-weight: 600">Minute</div>
                  </div>
                  <v-list class="scrollable-list" ref="minuteList">
                    <v-list-item-group v-model="selectedMinutes" color="#050D92">
                      <v-list-item
                        v-for="(minute, index) in minutes"
                        :key="`minute-${index}`"
                        :value="minute"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ minute }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </div>
                <div
                  style="border: 1px solid #a8a8a8; border-radius: 4px; padding: 5px;"
                >
                  <div style="text-align: center; padding: 2px">
                    <div style="font-size: 16px; font-weight: 600">AM/PM</div>
                  </div>
                  <v-list class="scrollable-list">
                    <v-list-item-group v-model="selectedPeriods" color="#050D92">
                      <v-list-item
                        v-for="(period, index) in periods"
                        :key="`period-${index}`"
                        :value="period"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ period }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </div>
              </div>
            </section>
          </div>
          <div style="margin-top: -5px; text-align: center">
            <v-btn
              small
              dark
              color="#FF4F1F"
              @click="confirmSelection"
              :disabled="disabled"
            >
              Save
            </v-btn>
            <v-btn
              small
              outlined
              color="#FF4F1F"
              style="margin-left: 10px"
              @click="cancelSelection"
              :disabled="disabled"
            >
              Clear
            </v-btn>
          </div>
        </v-card>
      </v-menu>
    </div>
  </template>

  <script>
  import {
    dateTimeStringConverter,
    convertDate
  } from "../../../Services/Utils/DateTimeFormatter";
  import { minutesArray, hoursArray } from "../../../Constants/Utils/Statics";

  export default {
    name: "DateTimePickerQuickTest",
    props: {
      value: {
        type: String,
        default: ""
      },
      width: {
        type: [String, Number],
        default: "30%"
      },
      disabled: {
        type: Boolean,
        default: false
      },
      conduction: {
        type: String,
        default: "1"
      }
    },
    data() {
      return {
        menu: false,
        selectedDate: null,
        selectedHours: "",
        selectedMinutes: "",
        selectedPeriods: "",
        hours: hoursArray,
        minutes: minutesArray,
        periods: ["AM", "PM"]
      };
    },
    computed: {
      transformedValue() {
        if (!this.value) return "";
        const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4} (0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
        if (!regex.test(this.value)) {
          return dateTimeStringConverter(this.value).timeString;
        }
        return this.value;
      },
      inputWrapperStyle() {
        const width = typeof this.width === "number" ? `${this.width}px` : this.width;
        return { width };
      },
      minDate() {
        console.log('this.conduction', this.conduction);
        const date = new Date();
        return this.conduction === "1"
          ? date.toISOString().split("T")[0]
          : null;
      },
      maxDate() {
        const date = new Date();
        return this.conduction === "2"
          ? date.toISOString().split("T")[0]
          : null;
      }
    },
    methods: {
      confirmSelection() {
        const formattedDate = convertDate(this.selectedDate || new Date());
        const hours = this.selectedHours || "01";
        const minutes = this.selectedMinutes || "00";
        const period = this.selectedPeriods || "AM";
        this.$emit("input", `${formattedDate} ${hours}:${minutes} ${period}`);
        this.menu = false;
      },
      cancelSelection() {
        this.selectedDate = null;
        this.selectedHours = "";
        this.selectedMinutes = "";
        this.selectedPeriods = "";
        this.$emit("input", "");
        this.menu = false;
      },
      onDateInput() {
        // Ensure selectedDate is set in proper format
        this.selectedDate = this.selectedDate
          ? this.selectedDate.toISOString().split("T")[0]
          : null;
      }
    }
  };
  </script>

  <style scoped>
  .scrollable-list {
    height: 200px;
    overflow-y: auto;
    scroll-behavior: smooth;
  }
  .scrollable-list::-webkit-scrollbar {
    width: 2px;
  }
  .scrollable-list::-webkit-scrollbar-track {
    background: transparent;
  }
  .scrollable-list::-webkit-scrollbar-thumb {
    background: #898888;
  }
  </style>
